<template>
    <a href="#" class="dropdown-item" @click.prevent="logout">
        <i class="tim-icons icon-button-power"></i>
        <span>{{ $t('auth.log-out') }}</span>
    </a>
</template>

<script>
    export default {

        props: {
            endpoint: {
                type: String,
                default: '/trax/api/auth/logout'
            },
            redirectRouteName: {
                type: String,
                default: 'login'
            }
        },

        methods: {
            logout() {
                this.error = null;
                axios.post(this.endpoint)
                    .then(resp => {
                        this.$router.push({ name: this.redirectRouteName });
                    })
            }
        }
    }
</script>
